import React from "react";
import Links from "../../../components/Links";

const getCurrentYear  = () => new Date().getFullYear();
export default () => (
    <footer id="footer">
        <Links/>
        <ul className="copyright">
            <li>&copy; Ispire tt {getCurrentYear()} .</li>
        </ul>
    </footer>



)